import React from "react";

import AddToAppleWallet from "./AddToAppleWallet";

const AddToAppleWalletContainer = ({ addToAppleWalletIconUrl, pkPassesEndpoint, orderId }) => {
  const href = pkPassesEndpoint || `/my_orders/${orderId}/pk_passes`;

  return (
    <AddToAppleWallet
      addToAppleWalletIconUrl={addToAppleWalletIconUrl}
      href={href}
    />
  );
};

export default AddToAppleWalletContainer;
